import axios from 'axios';

import appSettings from '../app-settings';

const ACCOUNTS_URL = `${appSettings.baseUrl}/accounts`;

export const getUsage = async () => axios.get(`${ACCOUNTS_URL}/usage`);

export const getDocuments = async () => axios.get(`${ACCOUNTS_URL}/documents`);

export const deleteDocument = async (name) => axios.delete(`${ACCOUNTS_URL}/documents/${name}`);

export const editDocument = async (name, data) => axios.patch(`${ACCOUNTS_URL}/documents/${name}`, data);
